import React from "react";
import { Grid } from "semantic-ui-react";
import { connect } from "react-redux";
import CaseMap from "./CaseMap";
import CaseList from "./CaseList";
import SiteContext from "../contexts";
import { fetchCasesIfNeeded } from "../actions";
import selectors from "../selectors";

import "./App.scss";

const defaultProps = {
  cases: [],
};
type Props = {
  cases: Array<Record<string, unknown>>;
  location: any;
  dispatch: any;
  filterId: any;
} & Partial<DefaultProps>;
type DefaultProps = Readonly<typeof defaultProps>;

const initialState = {
  caseSelected: null,
  caseHovered: null,
  markers: {},
};
type State = {
  markers: any;
  caseSelected: any;
  caseHovered: any;
} & Partial<InitialState>;
type InitialState = Readonly<typeof initialState>;

class App extends React.Component<Props, State> {
  readonly state: State = initialState;
  static defaultProps = defaultProps;

  componentDidMount() {
    const { dispatch, filterId } = this.props;
    dispatch(fetchCasesIfNeeded(filterId));
  }

  onListItemClicked = (caseObj: any) => {
    this.setState({ caseSelected: caseObj });
  };

  onListItemHovered = (caseObj: any) => {
    caseObj !== this.state.caseHovered &&
      this.setState({
        caseHovered: caseObj,
      });
  };

  onMarkerClicked = (caseObj: any) => {
    this.setState({ caseSelected: caseObj });
  };

  onMarkerHovered = (caseObj: any) => {
    caseObj !== this.state.caseHovered &&
      this.setState({
        caseHovered: caseObj,
      });
  };

  renderMap() {
    return (
      <CaseMap
        cases={this.props.cases}
        caseSelected={this.state.caseSelected}
        caseHovered={this.state.caseHovered}
        onMarkerHovered={this.onMarkerHovered}
        onMarkerClicked={this.onMarkerClicked}
      />
    );
  }

  renderList() {
    return (
      <CaseList
        cases={this.props.cases}
        caseSelected={this.state.caseSelected}
        caseHovered={this.state.caseHovered}
        onListItemHovered={this.onListItemHovered}
        onListItemClicked={this.onListItemClicked}
      />
    );
  }

  render() {
    const site: string = selectors.site(this.state, this.props);
    return (
      <SiteContext.Provider value={{ site }}>
        <Grid className='App' columns='equal'>
          <Grid.Row columns='equal'>
            <Grid.Column className='CaseList'>{this.renderList()}</Grid.Column>
            <Grid.Column className='CaseMap'>{this.renderMap()}</Grid.Column>
          </Grid.Row>
        </Grid>
      </SiteContext.Provider>
    );
  }
}

function mapStateToProps(state: any, props: any) {
  const filterId = selectors.filterId(state, props);
  const cases = selectors.cases(state, props);
  return {
    cases,
    filterId,
  };
}
export default connect(mapStateToProps)(App);
